<!-- <h3>{{ gridName }}</h3> -->
<div
  class=""
  id="gridListContainer"
  *ngIf="isDocumentAvailable"
  (window:resize)="onResize($event)"
>
  <table *ngIf="mobileView" class="table" datatable [dtOptions]="dtOptions">
    <thead class="">
      <tr>
        <th>ACTION</th>
        <th [ngStyle]="{ width: pageName != 'pending' ? '200px' : '' }">
          DUE
        </th>
        <th>FORM</th>
        <!-- <th *ngIf="pageName != 'pending'">FILE NAME</th> -->
        <th>STATUS</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let items of tableData; let i = index" role="row">
        <td>
          <div class="btn-block" *ngIf="pageName != 'pending'">
            <div class="wrap-text" *ngIf="items.uploaded">
              {{ selectedFile?.name }}
            </div>
            <div *ngIf="checkStatusReviewDoc(items.uploaded)">
              <span *ngFor="let btnType of items.Actions">
                <input
                  type="file"
                  class="file"
                  accept=".pdf"
                  *ngIf="!items.uploaded && isFileUploadAction(btnType)"
                  [attr.id]="'file' + i"
                  (change)="
                    handleFileInput($event.target.files, items.Status, i)
                  "
                />

                <span *ngIf="!items.uploaded && isFilloutFormAction(btnType)">
                  <button
                    type="button"
                    class="btn btn-primary btn-width secondaryBtn"
                    (click)="fillOutForm(items, btnType, i)"
                  >
                    {{ btnType.ButtonType }}
                  </button>
                </span>

                <span *ngIf="!items.uploaded && isDownloadAction(btnType)">
                  <button
                    type="button"
                    class="btn btn-primary btn-width secondaryBtn"
                    (click)="downloadApp(items, btnType, i)"
                  >
                    {{ btnType.ButtonType }}
                  </button>
                </span>
              </span>
            </div>
            <div *ngFor="let btnType of items.Actions">
              <div *ngIf="isFileUploadAction(btnType)">
                <button
                  type="button"
                  class="btn btn-primary btn-width mar-rit5"
                  [class.disabled]="!uploadBtnFlag"
                  *ngIf="items.uploaded"
                  (click)="upload(items, i, btnType)"
                >
                  {{ siteCoreData.buttons[0].keyText }}
                </button>

                <button
                  type="button"
                  class="btn btn-primary btn-width secondaryBtn"
                  (click)="removeDoc(i)"
                  *ngIf="items.uploaded"
                >
                  {{ siteCoreData.buttons[1].keyText }}
                </button>
              </div>
            </div>
          </div>
        </td>
        <td>{{ items.Due }}</td>
        <td *ngIf="isApiPathAvailable(items)">
          <a (click)="downloadPdfFile(items?.FileName)">{{
            items.Form?.Name
          }}</a>
        </td>
        <td *ngIf="!isApiPathAvailable(items)">
          {{ items.Form?.Name }}
        </td>
        <!-- <td *ngIf="pageName != 'pending'">
          <span class="wrap-text" *ngIf="isApiPathAvailable(items)"
            ><a (click)="downloadPdfFile(items?.FileName)">{{
              items.fName
            }}</a></span
          >
          <span class="wrap-text" *ngIf="!isApiPathAvailable(items)">{{
            items.fName ? items.fName : ''
          }}</span>
        </td> -->

        <td>{{ items.Status }}</td>
      </tr>
    </tbody>
  </table>

  <!-- Desktop View -->
  <table *ngIf="!mobileView" class="table" datatable [dtOptions]="dtOptions">
    <thead class="">
      <tr>
        <th>DUE</th>
        <th [ngStyle]="{ width: pageName != 'pending' ? '200px' : '' }">
          FORM
        </th>
        <!-- <th *ngIf="pageName != 'pending'">FILE NAME</th> -->
        <th>ACTION</th>
        <th>STATUS</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let items of tableData; let i = index">
        <td>{{ items.Due }}</td>
        <td *ngIf="isApiPathAvailable(items)">
          <a (click)="downloadPdfFile(items?.FileName)">{{
            items.Form?.Name
          }}</a>
        </td>
        <td *ngIf="!isApiPathAvailable(items)">
          {{ items.Form?.Name }}
        </td>
        <!--<td *ngIf="pageName != 'pending'">          
           <span class="wrap-text" *ngIf="isApiPathAvailable(items)"
            ><a (click)="downloadPdfFile(items?.FileName)">{{
              items.fName
            }}</a></span
          >
          <span class="wrap-text" *ngIf="!isApiPathAvailable(items)">{{
            items.fName ? items.fName : ''
          }}</span> 
        </td>-->
        <td>
          <div class="wrap-text" *ngIf="items.uploaded">
            {{ selectedFile?.name }}
          </div>
          <div class="btn-block display-flex" *ngIf="pageName != 'pending'">
            <!-- <span *ngIf="isUploadFile">
              <div class="row circle-loading">                
                <div class="col-4">
                  <span
                    class="animated-circle animation-circle-height d-block"
                  ></span>
                </div>
              </div>
            </span>  -->

            <div
              *ngIf="checkStatusReviewDoc(items.uploaded)"
              style="display: contents;"
            >
              <span
                *ngFor="let btnType of items.Actions"
                [class.relative]="btnType.ButtonType !== 'Edit Form'"
              >
                <input
                  type="file"
                  class="file"
                  accept=".pdf"
                  *ngIf="!items.uploaded && isFileUploadAction(btnType)"
                  [attr.id]="'file' + i"
                  (change)="
                    handleFileInput($event.target.files, items.Status, i)
                  "
                />

                <span *ngIf="!items.uploaded && isFilloutFormAction(btnType)">
                  <button
                    type="button"                                        
                    [ngClass]="btnType.ButtonType === 'Re-Upload'? 'btn btn-primary btn-width secondaryBtn' : 'btn btn-primary btn-width' "
                    (click)="fillOutForm(items, btnType, i)"
                  >
                    {{ btnType.ButtonType }}
                  </button>
                </span>

                <span *ngIf="!items.uploaded && isDownloadAction(btnType)">
                  <button
                    type="button"
                    class="btn btn-primary btn-width secondaryBtn"
                    (click)="downloadApp(items, btnType, i)"
                  >
                    {{ btnType.ButtonType }}
                  </button>
                </span>
              </span>
            </div>

            <div
              style="display: contents;"
              *ngFor="let btnType of items.Actions"
            >
              <div
                style="display: contents;"
                *ngIf="isFileUploadAction(btnType)"
              >
                <button
                  type="button"
                  class="btn btn-primary btn-width mar-rit5"
                  [class.disabled]="!uploadBtnFlag"
                  *ngIf="items.uploaded"
                  (click)="upload(items, i, btnType)"
                >
                  {{ siteCoreData.buttons[0].keyText }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-width secondaryBtn"
                  (click)="removeDoc(i)"
                  *ngIf="items.uploaded"
                >
                  {{ siteCoreData.buttons[1].keyText }}
                </button>
              </div>
            </div>
          </div>

          <!--Fill Out Form
          <div
            class="btn-block"
            *ngIf="items.IsSLForm && pageName != 'pending'"
          >
            <button
              type="button"
              class="btn btn-primary btn-width"
              (click)="fillOutForm(items)"
            >
              Fill Out Form
            </button>
          </div>-->
        </td>

        <td>{{ items.Status }}</td>
      </tr>
    </tbody>
  </table>
</div>
